import React, { useLayoutEffect, useContext, useState, ReactNode } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Portal from 'src/layout/Portal/Portal';
import moment from 'moment';
import { Grid } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import useEventListener from 'src/hooks/useEventListener';
import { TModalFullScreen, TModalSize } from 'src/type/modal-type';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import { BsXCircleFill } from 'react-icons/bs';
import { StaffService } from 'src/services/UserServices';
// import showNotification from 'src/components/extras/showNotification';

export default function ModalProfile({ isOpen, exit }) {
	const [checkFa, setCheckFa] = useState(false);

	return (
		<div>
			<Portal>
				<AnimatePresence mode='wait'>
					{isOpen && (
						<>
							<motion.div
								initial={{ scale: 0 }}
								animate={{ rotate: 0, scale: 1 }}
								transition={{
									type: 'spring',
									stiffness: 260,
									damping: 20,
								}}
								key='modal'
								className='modal show'
								style={{ display: 'block' }}
								tabIndex={-1}
								aria-hidden='true'>
								<div
									className='modal-dialog
                                modal-dialog-scrollable
                                modal-dialog-centered'>
									<div className='modal-content'>
										<div className='div_edit_bar'>
											<div className='fw-bold h5'>Profile</div>
											<div className='div_exit' onClick={() => exit()}>
												<BsXCircleFill
													style={{ width: '15px', height: 'auto' }}
												/>
											</div>
										</div>
										<hr style={{ margin: '0px 0px 1rem 0px' }} />
										<div className='div_edit_content'>
											<div className='div_swicth_edit'>
												2Fa
												<div class='form-check form-switch'>
													<input
														class='form-check-input'
														type='checkbox'
														role='switch'
														name='withdraw_status'
														onChange={(e) =>
															setCheckFa(e.target.checked)
														}
														checked={checkFa}
													/>
												</div>
											</div>
											{/* <Button onClick={''} className='btn_save_edit'>
												<span>Save</span>
											</Button> */}
										</div>
									</div>
								</div>
							</motion.div>
							<div className='modal-backdrop show'></div>
						</>
					)}
				</AnimatePresence>
			</Portal>
		</div>
	);
}
